<template>
  <div class="flex-col">
    <div class="page u-flex-col u-col-center">
      <div class="header u-flex-col u-col-center">
        <div class="heder-logo"></div>
        <div class="header-title">恭喜您！已通过初审</div>
      </div>
      <div class="content u-flex-col u-col-center">
        <div class="content-icon"></div>
        <div class="content-title">预估额度(元)</div>
        <div class="content-count">200,000</div>
        <div class="content-count-1">
          *实际下款金额及利率请以最终审批结果为准
        </div>

        <div class="button-view">
          <div class="button" @click="goAppStore">
            <div class="button-text">立即下载app提现</div>
            <div class="button-arrow">优质用户专享额度</div>
          </div>
          <div class="button-arrow-1"></div>
        </div>

        <div class="content-bottom-text">- 平均8s完成下载安装 -</div>
      </div>
      <div class="bottom-image"></div>
      <div class="service-tel">客服电话:0755-8607 2464 (工作日 9:00-18:00)</div>
    </div>
    <!--    cpa弹窗-->
    <van-popup
      v-model="isShowPop"
      position="center"
      round
      v-if="this.popData.productName"
    >
      <div class="pop-countent">
        <div class="title-bg">
          <span class="title-text">点击去提现，立即拿钱</span>
          <span class="span-icon"></span>
        </div>
        <div class="countent">
          <img :src="this.popData.logo" class="product-logo" />
          <div class="product-infoBg flex-col justify-center">
            <div class="product-info">
              <div class="product-name">{{ popData.productName }}</div>
              <div class="product-num">{{ popData.loanAmount }}元</div>
            </div>
            <div class="product-tip flex-row items-center">
              <div class="product-tipImg"></div>
              <div class="product-tipTitle">秒申请，秒审核！两小时内放款</div>
            </div>
          </div>
        </div>
        <div class="agree-txt">
          <van-checkbox
            v-model="checked"
            class="check-box"
            shape="square"
          ></van-checkbox>
          <span class="txt">
            我已阅读并同意<i @click="handleProtocol(9)"
              >《个人信息查询授权书》
            </i></span
          >
        </div>
        <div class="btn-bg flex-row items-center justify-center">
          <div
            class="btn-cancel flex-row items-center justify-center"
            @click="handleCancelBtn"
          >
            确认离开
          </div>
          <div
            class="btn-confirm flex-row items-center justify-center"
            v-prevent-reclick
            @click="handlePopBtn"
          >
            去提现
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as API_Common from "@/api/common";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common";
export default {
  name: "download",
  data() {
    return {
      downAppUrl: undefined,
      channel: this.$route.query.source,
      checked: false,
      isShowPop: false,
      popData: {
        isShieldCity: false,
        linkUrl: undefined,
        isToRegister: undefined,
        productName: "",
        loanAmount: 0,
      },
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        redirectUrl: "",
        grantValue: "",
      },
    };
  },
  mounted() {
    API_Common.delayModel8SUpdate("haluo", 0, "0", 0);
    this.getDownloadUrl();
    this.preventBack(); // 调用方法阻止返回
    this.getPopProduct();
  },
  methods: {
    goAppStore() {
      API_Common.delayModel8SUpdate("haluo", 0, "0", 1);
      if (this.downAppUrl) {
        window.open(this.downAppUrl, "_blank");
      } else {
        API_Common.getDownloadUrl(this.channel).then((res) => {
          if (res.code === 200) {
            this.downAppUrl = res.data.url;
            window.open(this.downAppUrl, "_blank");
          }
        });
      }
    },
    // 根据渠道code和进行到哪一步查询配置H5弹窗产品权重最大的值
    getPopProduct() {
      API_Common.getPopItem(this.channel).then((res) => {
        if (res.code === 200 && !res.data.isShieldCity) {
          this.popData = res.data;
        } else {
          this.popData = [];
        }
      });
    },
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url;
        }
      });
    },

    handlePopBtn() {
      if (!this.checked) {
        this.$toast("请勾选同意个人信息查询授权书");
        return;
      }
      const buriedData = {
        productId: this.popData.productId,
        showPage: 7,
      };
      this.isShowPop = false;
      let redirectUrl = this.popData.linkUrl;
      let isWeCom = this.popData.isWeCom;
      if (this.popData.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.popData.productId,
          this.popData.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },

    handleCancelBtn() {
      this.isShowPop = false;
    },

    handleProtocol(pageType) {
      window.location.href = "/protocol.html?pageType=" + pageType;
    },

    // 阻止返回的方法
    preventBack() {
      history.pushState(null, document.title, location.href); // 将当前页面加入历史记录
      window.addEventListener("popstate", this.onPopState); // 监听 popstate 事件
    },

    // popstate 事件处理函数
    onPopState(event) {
      history.pushState(null, document.title, location.href); // 再次将当前页面加入历史记录
      this.isShowPop = true;
    },
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    this.isShowPop = false;
    window.removeEventListener("popstate", this.onPopState);
  },
};
</script>

<style scoped>
@import "../css/cpaPopView.scss";
@import "../css/protocolPopView.css";
@import "../css/modelBase.css";
@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes moveAnimation {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-10px, -10px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.button {
  animation: scaleAnimation 1.5s infinite;
}

.button-arrow-1 {
  animation: moveAnimation 1.5s infinite;
}

.page {
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #f4f5f6;
}

.header {
  width: 100%;
  height: 6.24rem;
  background-image: url("../../public/img/download/header_bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
}

.heder-logo {
  width: 3.64rem;
  height: 0.5rem;
  margin-top: 0.26rem;
  margin-left: -3.2rem;
  background-image: url("../../public/img/download/header_logo.png");
  background-size: 100%;
  background-repeat: no-repeat;
}

.header-title {
  margin-top: 0.84rem;
  font-family: SourceHanSansCN, SourceHanSansCN, serif;
  font-weight: bold;
  font-size: 0.56rem;
  color: #ffffff;
  line-height: 0.84rem;
  text-shadow: 0 0 0 rgba(179, 0, 0, 0.5);
  text-align: left;
  font-style: normal;
}

.content {
  width: 6.86rem;
  height: 6.76rem;
  background: #ffffff;
  border-radius: 0.1rem;
  margin-top: -3rem;
}

.content-icon {
  width: 2.54rem;
  height: 0.52rem;
  margin-top: -0.08rem;
  background-image: url("../../public/img/download/content_icon.png");
  background-size: 100%;
  background-repeat: no-repeat;
}

.content-title {
  font-family: PingFangSC, PingFang SC, serif;
  font-weight: 400;
  font-size: 0.28rem;
  color: #000000;
  line-height: 0.4rem;
  text-align: left;
  font-style: normal;
  margin-top: 0.62rem;
}

.content-count {
  font-family: DINMittelschrift, serif;
  font-size: 1.32rem;
  color: #000000;
  line-height: 1.58rem;
  text-align: left;
  font-style: normal;
  margin-top: 0.04rem;
}

.content-count-1 {
  font-family: PingFangSC, PingFang SC, serif;
  font-weight: 400;
  font-size: 0.24rem;
  color: #bdbdbd;
  text-align: left;
  font-style: normal;
  margin-top: 0.2rem;
}

.button-view {
  margin-bottom: 0.56rem;
}

.button {
  width: 6.1rem;
  height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.7rem;
  background: #d93c3a;
  border-radius: 0.48rem;
}

.button-text {
  font-family: PingFangSC, PingFang SC, serif;
  font-weight: 500;
  font-size: 0.34rem;
  color: #ffffff;
}

.button-arrow {
  width: 2.3rem;
  height: 0.4rem;
  background: linear-gradient(316deg, #ffd77a 0%, #ffa648 100%);
  border-radius: 0.2rem 0.2rem 0.2rem 0;
  font-family: PingFangSC, PingFang SC, serif;
  font-weight: 400;
  font-size: 0.2rem;
  color: #984100;
  line-height: 0.28rem;
  text-align: left;
  font-style: normal;
  margin-left: 3.5rem;
  margin-top: -1.2rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-arrow-1 {
  width: 1.11rem;
  height: 0.96rem;
  margin-top: -0.4rem;
  background-image: url("../../public/img/mt/button_arrow.png");
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  margin-left: 5rem;
}

.content-bottom-text {
  font-family: PingFangSC, PingFang SC, serif;
  font-weight: 500;
  font-size: 0.22rem;
  color: #999999;
  line-height: 0.32rem;
  text-align: center;
  font-style: normal;
}

.bottom-image {
  width: 6.86rem;
  height: 3.76rem;
  background-image: url("../../public/img/download/bottom_view.png");
  background-size: 100%;
  background-repeat: no-repeat;
  margin-top: 0.44rem;
}

.service-tel {
  font-size: 0.25rem;
  font-family: PingFangSC, serif;
  margin-top: 0.3rem;
  color: #d2a990;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 0.2rem;
}
</style>
